import * as constants from './constants';

const initialState = {
  allTemplates: [],
  createTemplateLoading: false,
  currentTemplateObj: {
    name: '',
    template_fields: [],
  },
  templateCreatedSuccess: false,
  templateEditSuccess: false,
  // fetchingLoading: false,
  updateLoading: false,
  totalRecords: 0,
  isAdding: false,
  fetchTemplateLoading: false,
  documentTemplateIsEdit: false,
  deleteTemplateLoading: false,
};

const templatesManagerReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.DOCUMENT_TEMPLATE_IS_EDIT:
      return {
        ...state,
        documentTemplateIsEdit: action.data,
      };
    case constants.CREATE_TEMPLATE:
      return {
        ...state,
        templateEditSuccess: false,
        createTemplateLoading: true,
        templateCreatedSuccess: false,
        DocumentTemplateIsEdit: false,
      };
    case constants.CREATE_TEMPLATE_SUCCESS:
      const templateFields = action.data.template_fields.map((el) => ({
        ...el,
        isEdit: false,
        isLocal: false,
        options: el.field_options.map((ele) => ({
          ...ele,
          isEdit: false,
          isLocal: false,
        })),
      }));

      return {
        ...state,
        createTemplateLoading: false,
        DocumentTemplateIsEdit: false,
        templateCreatedSuccess: true,
        templateEditSuccess: false,
        currentTemplateObj: {
          ...action.data,
          template_fields: templateFields,
        },
      };
    case constants.CREATE_TEMPLATE_ERROR:
      return {
        ...state,
        createTemplateLoading: false,
        templateCreatedSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES:
      return {
        ...state,
        fetchTemplateLoading: true,
        templateCreatedSuccess: false,
        templateEditSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES_SUCCESS:
      const { templates } = action.data;
      return {
        ...state,
        fetchTemplateLoading: false,
        isAdding: false,
        allTemplates: templates,
        // totalRecords: total_document_templates,
        templateCreatedSuccess: false,
        DocumentTemplateIsEdit: false,
        templateEditSuccess: false,
      };
    case constants.FETCH_ALL_TEMPLATES_ERROR:
      return {
        ...state,
        fetchTemplateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
        templateEditSuccess: false,
      };
    case constants.UPDATE_TEMPLATE:
      return {
        ...state,
        updateLoading: true,
        templateCreatedSuccess: false,
      };
    case constants.UPDATE_TEMPLATE_SUCCESS:
      // const updated = state.allTemplates.map((el) =>
      //   el.id === action.data.id ? { ...el, ...action.data } : el
      // );
      return {
        ...state,
        // allTemplate: updated,
        updateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
        DocumentTemplateIsEdit: false,
        templateEditSuccess: true,
      };
    case constants.UPDATE_TEMPLATE_ERROR:
      return {
        ...state,
        updateLoading: false,
        isAdding: false,
        templateCreatedSuccess: false,
      };
    case constants.DELETE_TEMPLATE:
      return {
        ...state,
        templateEditSuccess: false,
        deleteTemplateLoading: true,
        templateCreatedSuccess: false,
        DocumentTemplateIsEdit: false,
      };
    case constants.DELETE_TEMPLATE_SUCCESS:
      let updatedTemplate = state.allTemplates.filter(
        (el) => el.id !== action.data.id
      );
      let totalRecords = state.totalRecords - 1;
      return {
        ...state,
        totalRecords: totalRecords,
        fetchTemplatesLoading: false,
        allTemplates: updatedTemplate,
      };
    case constants.DELETE_TEMPLATE_ERROR:
      return {
        ...state,
        fetchTemplatesLoading: false,
      };

    case constants.IS_ADDING_UPDATE:
      return {
        ...state,
        isAdding: action.data,
      };
    case constants.FETCH_TEMPLATE:
      return {
        ...state,
        fetchTemplateLoading: true,
        templateCreatedSuccess: false,
      };
    case constants.FETCH_TEMPLATE_SUCCESS:
      const { template_fields } = action.data;

      const updatedTemplateFields = template_fields
        ? template_fields.map((el) => ({
            ...el,
            isEdit: false,
            isLocal: false,
            options: el.field_options.map((ele) => ({
              ...ele,
              isEdit: false,
              isLocal: false,
            })),
          }))
        : [];

      return {
        ...state,
        fetchTemplateLoading: false,
        templateCreatedSuccess: false,
        currentTemplateObj: {
          ...action.data,
          template_fields: updatedTemplateFields,
        },
      };
    case constants.FETCH_TEMPLATE_ERROR:
      return {
        ...state,
        fetchTemplateLoading: false,
        templateCreatedSuccess: false,
      };
    // default:
    //   return state;
    case constants.TEMPLATE_CREATION_CLEANUP_FUNC:
      return {
        ...state,
        allTemplates: [],
        createTemplateLoading: false,
        currentProjectObj: {},
        templateDetailsIsEdit: false,
        fetchTemplateLoading: false,
        deletePTemplateLoading: false,
        templateEditSuccess: false,
        currentTemplateObj: {
          name: '',
          template_fields: [],
        },
        // projectNotificationIsEdit: false,
      };
    default:
      return state;
  }
};

export default templatesManagerReducer;
